let Photos1990=[
  {
    "NameEN": "1990",
    "Image": "un23",
    "CaptionEN": "Nelson Mandela's first appearance at the UN, 1990 [AP Photo]",
    "CaptionAR": "نيلسون مانديلا في ظهوره الأول في الأمم المتحدة عام 1990 (أسوشيتد برس)"
  },
  {
    "NameEN": null,
    "Image": "un27",
    "CaptionEN": "A domestic violence victim at a safe house in New York, 1996. In December 1999, the UNGA declared November 25 as \"International Day for the Elimination of Violence against Women\" [Getty Images]",
    "CaptionAR": "ضحية للعنف المنزلي في مأوى بنيويورك عام 1996. في العام 1999 أعلنت الجمعية العامة 25 نوفمبر/تشرين الأول يوما لاجتثاث العنف ضد النساء (غيتي)"
  },
  {
    "NameEN": null,
    "Image": "un26",
    "CaptionEN": "Former Bosnian Serbian commander and convicted war criminal Ratko Mladic, 1993 [AP Photo]",
    "CaptionAR": "الزعيم السابق لصرب البوسنة راتكو ملاديتش المتهم بارتكاب جرائم حرب في البوسنة والهرسك عام 1993 (أسوشيتد برس)"
  },
  {
    "NameEN": null,
    "Image": "un25",
    "CaptionEN": "An oil well blown up by Iraqi forces during the first Gulf War, 1991 [Getty Images]",
    "CaptionAR": "حريق في حقل نفطي خلال حرب الخليج الأولى عام 1991 (غيتي)"
  },
  {
    "NameEN": null,
    "Image": "un24",
    "CaptionEN": "Mikhail Gorbachev and Boris Yeltsin marking the end of the Soviet Union, 1991 [Getty Images]",
    "CaptionAR": "ميخائيل غورباتشوف وبوريس يلتسن يعلنان نهاية الاتحاد السوفياتي عام 1991 (غيتي)"
  }
]
export default Photos1990